import appLanding from "./views/appLanding";

export default {
  path: "/",
  name: "Landing",
  component: appLanding,
};
